





import {Component, Vue, Prop} from 'vue-property-decorator'
import {setTimeout, clearTimeout} from 'timers'

@Component({})
export default class Touch extends Vue {
  @Prop({type: [String, Object], default: ''}) public touchClass!: string

  public touchStartTime = 0
  public touchEndTime = 0
  public move = false
  public longPress: any = null

  public touchMove(e: any) {
    this.move = true
    this.$emit('move')
    clearTimeout(this.longPress)
  }

  public touchStart(e: any) {
    this.longPress = setTimeout(this.touchPress, 500)

    this.$emit('start')
    this.touchStartTime = e.timeStamp
  }

  public touchEnd(e: any) {
    clearTimeout(this.longPress)

    if (this.move) {
      this.move = false
      return false
    }
    this.$emit('end')
    this.touchEndTime = e.timeStamp
    this.touch(e)
  }

  public touchPress() {
    this.$emit('press')
  }

  public touch(e: any) {

    const time = this.touchEndTime - this.touchStartTime

    if (time < 500) {
      this.$emit('tap')
    }

    this.touchEndTime = 0
    this.touchStartTime = 0

  }

}

